import request from "@/utils/request"
//获取一体柜的时序控制Page列表
export function GetCabinetPagelist(data) {
  return request({
    url: "/Anno.Plugs.PowerControl/TimelyControl/GetCabinetPagelist",
    method: "post",
    data
  })
}
///获取分支箱的时序控制Page列表
export function GetBranchBoxPagelist(data) {
  return request({
    url: "/Anno.Plugs.PowerControl/TimelyControl/GetBranchBoxPagelist",
    method: "post",
    data
  })
}
//保存时序控制
export function Add(data) {
  return request({
    url: "Anno.Plugs.PowerControl/TimelyControl/Add",
    method: "post",
    data
  })
}
//新增并发送指令
export function SendTimelyControl(data) {
  return request({
    url: "Anno.Plugs.PowerControl/TimelyControl/SendOrder",
    method: "post",
    data
  })
}
//删除
export function Delete(data) {
  return request({
    url: "Anno.Plugs.PowerControl/TimelyControl/Delete",
    method: "post",
    data
  })
}

//根据ID发送指令
export function SendOrderById(params) {
  return request({
    url: "Anno.Plugs.PowerControl/TimelyControl/SendOrderById",
    method: "get",
    params
  })
}
